export default "__VITE_ASSET__HSCK7bPq__"